/**
 * Member roles for organization membership.
 * These roles determine what actions a user can perform within an organization/team.
 */
export const MemberRole = {
  OWNER: "owner",
  ADMIN: "admin",
  MEMBER: "member",
} as const;

export type MemberRole = (typeof MemberRole)[keyof typeof MemberRole];

/**
 * User roles independent of organization membership.
 * These are system-level roles.
 */
export const UserRole = {
  ADMIN: "admin",
  USER: "user",
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

/**
 * All member roles as an array for use in dropdowns, etc.
 */
export const ALL_MEMBER_ROLES = [
  MemberRole.MEMBER,
  MemberRole.ADMIN,
  MemberRole.OWNER,
] as const;

/**
 * Member roles that can be assigned when inviting or editing members.
 * Excludes 'owner' as that role cannot be assigned through normal flows.
 */
export const EDITABLE_MEMBER_ROLES = [
  MemberRole.MEMBER,
  MemberRole.ADMIN,
] as const;

export type EditableMemberRole = (typeof EDITABLE_MEMBER_ROLES)[number];

/**
 * Helper to create role options for UI dropdowns
 */
export const MEMBER_ROLE_OPTIONS = ALL_MEMBER_ROLES.map((role) => ({
  value: role,
  label: role.charAt(0).toUpperCase() + role.slice(1),
}));
